import DynamicComponentError from "%/errors/dynamic-component-error";
import { mergeArrayOfClassInstances } from "@bloglovin/vue-framework";
import VerticalContainer from "%/dynamic-components/render-engine/components/elements/layouts/VerticalContainer.vue";
import HorizontalContainer
  from "%/dynamic-components/render-engine/components/elements/layouts/HorizontalContainer.vue";
import ImageElement
  from "%/dynamic-components/render-engine/components/production/elements/image-element/ImageElement.vue";
import TextElement
  from "%/dynamic-components/render-engine/components/production/elements/text-element/TextElement.vue";
import UrlElement from "%/dynamic-components/render-engine/components/production/elements/url-element/UrlElement.vue";
import ComponentName from "%/dynamic-components/render-engine/options/root-options/component-name";
import ComponentDescription from "%/dynamic-components/render-engine/options/root-options/component-description";
import SpacerElement
  from "%/dynamic-components/render-engine/components/production/elements/spacer-element/SpacerElement.vue";
import ButtonElement
  from "%/dynamic-components/render-engine/components/production/elements/button-element/ButtonElement.vue";
import VideoElement
  from "%/dynamic-components/render-engine/components/production/elements/video-element/VideoElement.vue";
import VerticalContainerProduction
  from "%/dynamic-components/render-engine/components/production/elements/layouts/VerticalContainerProduction.vue";
import HorizontalContainerProduction
  from "%/dynamic-components/render-engine/components/production/elements/layouts/HorizontalContainerProduction.vue";
import DisplayName from "%/dynamic-components/render-engine/options/root-options/display-name";
import BrandedNoteElement
  from "%/dynamic-components/render-engine/components/production/elements/text-element/BrandedNoteElement.vue";
import BrandedLabelElement
  from "%/dynamic-components/render-engine/components/production/elements/text-element/BrandedLabelElement.vue";
import BrandedHeadingElement
  from "%/dynamic-components/render-engine/components/production/elements/text-element/BrandedHeadingElement.vue";
import BrandedParagraphElement
  from "%/dynamic-components/render-engine/components/production/elements/text-element/BrandedParagraphElement.vue";
import BrandedSubHeadingElement
  from "%/dynamic-components/render-engine/components/production/elements/text-element/BrandedSubHeadingElement.vue";
import BrandedTitleElement
  from "%/dynamic-components/render-engine/components/production/elements/text-element/BrandedTitleElement.vue";
import CustomHtmlElement
  from "%/dynamic-components/render-engine/components/production/elements/custom-html-element/CustomHtmlElement.vue";

import AdUnit from "~/dynamic-components/standard-elements/AdUnit.vue";
import Icon from "~/dynamic-components/standard-elements/Icon.vue";
import CarouselContainer from "%/dynamic-components/render-engine/components/elements/layouts/CarouselContainer.vue";
import CarouselContainerProduction
  from "%/dynamic-components/render-engine/components/production/elements/layouts/CarouselContainerProduction.vue";
import PrimaryNavigation from "~/dynamic-components/shared-elements/navigation/PrimaryNavigation.vue";
import Container from "%/dynamic-components/render-engine/components/elements/layouts/Container.vue";
import ContainerProduction
  from "%/dynamic-components/render-engine/components/production/elements/layouts/ContainerProduction.vue";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import RequiredContexts from "%/dynamic-components/render-engine/options/root-options/required-contexts";
import DynamicAppTextElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppTextElement.vue";
import DynamicAppTagListElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppTagListElement.vue";
import DynamicAppDateElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppDateElement.vue";
import DynamicAppFeedElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppFeedElement.vue";
import PlatformFeedElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/PlatformFeedElement.vue";
import DynamicAppImageElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppImageElement.vue";
import DynamicAppVideoElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppVideoElement.vue";
import DynamicAppButtonElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppButtonElement.vue";
import DynamicAppStoryElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/display/DynamicAppStoryElement.vue";
import DynamicAppStoryInputElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/inputs/DynamicAppStoryInputElement.vue";
import DynamicAppRichTextInputElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/inputs/DynamicAppRichTextInputElement.vue";
import DynamicAppTextInputElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/inputs/DynamicAppTextInputElement.vue";
import DynamicAppNumberInputElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/inputs/DynamicAppNumberInputElement.vue";
import DynamicAppCheckboxInputElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/inputs/DynamicAppCheckboxInputElement.vue";
import DynamicAppEnumInputElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/inputs/DynamicAppEnumInputElement.vue";
import DynamicAppDateInputElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/inputs/DynamicAppDateInputElement.vue";
import DynamicAppVideoInputElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/inputs/DynamicAppVideoInputElement.vue";
import DynamicAppImageInputElement
  from "%/dynamic-components/render-engine/components/production/elements/dynamic-app-elements/inputs/DynamicAppImageInputElement.vue";
import HorizontalContainerWrapper
  from "%/dynamic-components/render-engine/components/elements/layouts/HorizontalContainerWrapper.vue";
import VerticalContainerWrapper
  from "%/dynamic-components/render-engine/components/elements/layouts/VerticalContainerWrapper.vue";
import InvalidElement from "%/dynamic-components/render-engine/components/elements/InvalidElement.vue";


export default class BaseDynamicComponent {

  static baseProductionElements = {
    [VerticalContainer.name]: VerticalContainerProduction,
    [HorizontalContainer.name]: HorizontalContainerProduction,
    [CarouselContainer.name]: CarouselContainerProduction,
    [Container.name]: ContainerProduction,
    [VerticalContainerWrapper.name]: ContainerProduction,
    [HorizontalContainerWrapper.name]: ContainerProduction,
  };

  static baseElements = [
    VerticalContainer,
    HorizontalContainer,
    CarouselContainer,
    HorizontalContainerWrapper,
    VerticalContainerWrapper,
    Container,
    ImageElement,
    VideoElement,
    ButtonElement,
    TextElement,
    UrlElement,
    CustomHtmlElement,
    SpacerElement,
    BrandedHeadingElement,
    BrandedSubHeadingElement,
    BrandedTitleElement,
    BrandedLabelElement,
    BrandedParagraphElement,
    BrandedNoteElement,
    AdUnit,
    Icon,
    PrimaryNavigation,
    InvalidElement,
  ];

  static elementsWithContext = [
    DynamicAppTextElement,
    DynamicAppTagListElement,
    DynamicAppDateElement,
    DynamicAppFeedElement,
    PlatformFeedElement,
    DynamicAppImageElement,
    DynamicAppVideoElement,
    DynamicAppButtonElement,
    DynamicAppStoryElement,
    DynamicAppStoryInputElement,
    DynamicAppRichTextInputElement,
    DynamicAppTextInputElement,
    DynamicAppNumberInputElement,
    DynamicAppCheckboxInputElement,
    DynamicAppEnumInputElement,
    DynamicAppDateInputElement,
    DynamicAppVideoInputElement,
    DynamicAppImageInputElement,
  ];

  static get standardElementVueComponents() {
    return [
      ...this.baseElements,
      ...this.elementsWithContext,
    ];
  }

  static standardOptionClasses = [
    new ComponentName("", true),
    new DisplayName("", true),
    ComponentDescription,
    RequiredContexts,
  ];

  static possibleElementVueComponents = [];
  static possibleOptionClasses = [];

  constructor() {
    if (!Object.prototype.hasOwnProperty.call(this.constructor, "getPossibleElements")) {
      throw new DynamicComponentError("getPossibleElements is not defined in component", {
        componentName: this.name,
      });
    }
  }

  static collectMixins(comp) {
    const allMixins = [];
    if (comp.mixins && Array.isArray(comp.mixins)) {
      comp.mixins.forEach(mixin => {
        this.collectMixins(mixin);
        allMixins.push(mixin);
      });
    }

    return allMixins;
  }

  static getAllMixins(component) {
    const allMixins = [];
    allMixins.push(...this.collectMixins(component));
    return allMixins;
  }

  static processElementVueComponents(elementVueComponents) {

    elementVueComponents.forEach(component => {
      let elementPanelSettings = {};
      let options = [];
      let optionBundles = [];
      let availableStates = [...Object.values(BaseOption.$states)];
      let optionsOrder = ["lock-options", "appearance", "animations"];
      let brandingType = null;

      const extendedComponent = component.extends;

      if (extendedComponent) {
        elementPanelSettings = {
          ...elementPanelSettings,
          ...extendedComponent.elementPanelSettings,
        };

        const allMixins = this.getAllMixins(extendedComponent).reverse();
        allMixins.forEach(mixin => {
          elementPanelSettings = {
            ...elementPanelSettings,
            ...mixin.elementPanelSettings ?? {},
          };

          options = mergeArrayOfClassInstances(options, mixin.options ?? []);
          optionBundles = mergeArrayOfClassInstances(optionBundles, mixin.optionBundles ?? []);
          optionsOrder = mergeArrayOfClassInstances(optionsOrder, mixin.optionsOrder ?? []);
          availableStates = mergeArrayOfClassInstances(availableStates, mixin.availableStates ?? []);
          brandingType = brandingType ?? mixin.brandingType;
        });
      }


      const allMixins = this.getAllMixins(component).reverse();
      allMixins.forEach(mixin => {
        elementPanelSettings = {
          ...elementPanelSettings,
          ...mixin.elementPanelSettings ?? {},
        };

        options = mergeArrayOfClassInstances(options, mixin.options ?? []);
        optionBundles = mergeArrayOfClassInstances(optionBundles, mixin.optionBundles ?? []);
        optionsOrder = mergeArrayOfClassInstances(optionsOrder, mixin.optionsOrder ?? []);
        availableStates = mergeArrayOfClassInstances(availableStates, mixin.availableStates ?? []);
        brandingType = brandingType ?? mixin.brandingType;
      });

      elementPanelSettings = {
        ...elementPanelSettings,
        ...component.elementPanelSettings ?? {},
      };

      options = mergeArrayOfClassInstances(options, component.options ?? []);
      optionBundles = mergeArrayOfClassInstances(optionBundles, component.optionBundles ?? []);
      optionsOrder = mergeArrayOfClassInstances(optionsOrder, component.optionsOrder ?? []);
      availableStates = mergeArrayOfClassInstances(availableStates, component.availableStates ?? []);
      brandingType = brandingType ?? component.brandingType;

      component.elementPanelSettings = elementPanelSettings;
      component.options = options;
      component.optionBundles = optionBundles;
      component.optionsOrder = optionsOrder;
      component.availableStates = availableStates;
      component.brandingType = brandingType;
    });

    return elementVueComponents;
  }

  static getPossibleElements() {
    let possibleElementVueComponents = this.possibleElementVueComponents;
    if (!Array.isArray(this.possibleElementVueComponents)) {
      possibleElementVueComponents = [];
    }

    const elementVueComponents = [
      ...this.standardElementVueComponents,
      ...possibleElementVueComponents,
    ];

    return this.processElementVueComponents(elementVueComponents);
  }

  static getPossibleElementTypes() {
    return [
      ...this.standardElementVueComponents,
      ...this.possibleElementVueComponents,
    ].map(element => {
      return element.name;
    });
  }

  static getProductionElementVueComponent(elementComponentName) {
    const foundProductionReplacementKey = Object.keys(this.baseProductionElements).find(elementName => {
      return elementName === elementComponentName;
    });

    if (foundProductionReplacementKey) {
      return this.baseProductionElements[foundProductionReplacementKey];
    }

    return this.getElementVueComponent(elementComponentName);
  }

  static getElementVueComponent(elementComponentName) {
    const elementVueComponent = this.getPossibleElements().find(elementComponent => {
      return elementComponent.name === elementComponentName;
    });

    if (!elementVueComponent) {
      return null;
    }
    return elementVueComponent;
  }

  static getOptions() {
    if (!Array.isArray(this.possibleOptionClasses)) {
      throw new DynamicComponentError("possibleOptionClasses must be defined as an array in dynamic component", {
        possibleOptionClasses: this.possibleOptionClasses,
        componentName: this.name,
      });
    }

    return [
      ...this.standardOptionClasses,
      ...this.possibleOptionClasses,
    ];
  }
}
